interface ArticleTeaserItem {
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  imageUrl: string;
  imageAlt: string;
  slug: string;
  internal: boolean;
}

const teaserArticles: ArticleTeaserItem[] = [
  {
    title: 'What Is Sugargoo Spreadsheet? Complete 2026 Beginner Guide',
    excerpt: 'Learn everything about Sugargoo Spreadsheet — how it works, why thousands of shoppers rely on it, and how to discover amazing products across every category.',
    category: 'Beginner Guide',
    readTime: '12 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20organized%20digital%20product%20spreadsheet%20displayed%20on%20a%20modern%20sleek%20monitor%2C%20fashion%20sneakers%20neatly%20arranged%20on%20a%20minimal%20white%20desk%2C%20warm%20peach%20and%20sand%20palette%2C%20soft%20morning%20daylight%2C%20editorial%20photography&width=600&height=340&seq=teaser-1-v2&orientation=landscape',
    imageAlt: 'What Is Sugargoo Spreadsheet - Beginner Guide 2026',
    slug: '/article/what-is-sugargoo-spreadsheet',
    internal: true,
  },
  {
    title: 'Sugargoo Review 2026: Honest Analysis From Real Shoppers',
    excerpt: 'Comprehensive Sugargoo review covering product sourcing, warehouse service, shipping, pricing, and real user experiences. Find out if Sugargoo is right for you.',
    category: 'Review',
    readTime: '10 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20professional%20product%20review%20concept%20with%20star%20ratings%20on%20a%20minimal%20tablet%20screen%2C%20surrounded%20by%20modern%20desk%20accessories%2C%20warm%20sand%20and%20terracotta%20palette%2C%20soft%20natural%20lighting%2C%20editorial%20photography&width=600&height=340&seq=teaser-2-v2&orientation=landscape',
    imageAlt: 'Sugargoo Review 2026 - Platform ratings and honest analysis',
    slug: '/article/sugargoo-review-2026',
    internal: true,
  },
  {
    title: 'Sugargoo Shipping Cost Guide 2026: Real Price Breakdown',
    excerpt: 'Complete guide to Sugargoo shipping cost — understand shipping methods, weight calculation, delivery times, and proven strategies to minimize international shipping expenses.',
    category: 'Shipping',
    readTime: '8 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20shipping%20concept%20with%20stylish%20cardboard%20packages%20neatly%20stacked%20on%20a%20light%20wooden%20table%2C%20a%20small%20world%20globe%20nearby%2C%20warm%20cream%20and%20sand%20palette%2C%20natural%20daylight%2C%20modern%20editorial%20photography&width=600&height=340&seq=teaser-3-v2&orientation=landscape',
    imageAlt: 'Sugargoo Shipping Cost Guide 2026 - International shipping explained',
    slug: '/article/sugargoo-shipping-cost',
    internal: true,
  },
  {
    title: 'Sugargoo Coupon & Discount Code Guide: Save on Every Order',
    excerpt: 'Discover where to find active Sugargoo coupons, discount codes, and promotional deals. Maximize your savings with proven strategies for every international order.',
    category: 'Money Saving',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20shopping%20savings%20concept%20with%20discount%20tags%20and%20coupons%20on%20a%20minimal%20marble%20surface%2C%20surrounded%20by%20a%20wallet%20and%20shopping%20bag%2C%20warm%20peach%20and%20cream%20palette%2C%20soft%20natural%20lighting%2C%20modern%20editorial&width=600&height=340&seq=teaser-4-v2&orientation=landscape',
    imageAlt: 'Sugargoo Coupon and Discount Code Guide 2026',
    slug: '/article/sugargoo-coupon-discount',
    internal: true,
  },
  {
    title: 'Is Sugargoo Legit? Complete Safety & Trust Analysis 2026',
    excerpt: 'Honest analysis of Sugargoo legitimacy, safety features, warehouse system, payment security, and buyer protection. Everything shoppers need to know before ordering.',
    category: 'Trust & Safety',
    readTime: '9 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20trust%20and%20security%20concept%20with%20a%20subtle%20shield%20motif%20reflected%20on%20a%20clean%20glass%20surface%2C%20warm%20sand%20and%20soft%20terracotta%20palette%2C%20natural%20daylight%2C%20modern%20editorial%20photography%2C%20reassuring%20aesthetic&width=600&height=340&seq=teaser-5-v2&orientation=landscape',
    imageAlt: 'Is Sugargoo Legit - Trust and safety analysis for 2026',
    slug: '/article/is-sugargoo-legit-safe',
    internal: true,
  },
  {
    title: 'Sugargoo Warehouse Guide: Storage, QC Photos & Consolidation',
    excerpt: 'Complete guide to Sugargoo warehouse services including storage policies, quality control photos, item consolidation, and how to use the warehouse system effectively.',
    category: 'Guide',
    readTime: '8 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clean%20organized%20warehouse%20concept%20with%20neatly%20stacked%20packages%20on%20modern%20shelving%2C%20warm%20cream%20and%20soft%20terracotta%20palette%2C%20bright%20natural%20lighting%2C%20modern%20logistics%20aesthetic%2C%20editorial%20photography&width=600&height=340&seq=teaser-6-v2&orientation=landscape',
    imageAlt: 'Sugargoo Warehouse Guide 2026 - Storage and QC explained',
    slug: '/article/sugargoo-warehouse-guide',
    internal: true,
  },
  {
    title: 'Best Sugargoo Spreadsheet 2026: Ultimate Shopping Guide',
    excerpt: 'Discover the best Sugargoo Spreadsheet for 2026. Complete guide covering product categories, how to use spreadsheets, money-saving tips, and beginner tutorials.',
    category: 'Shopping Guide',
    readTime: '11 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylish%20shopping%20guide%20concept%20with%20a%20modern%20tablet%20displaying%20organized%20categories%2C%20fashion%20items%20around%20it%20on%20a%20minimal%20desk%2C%20warm%20peach%20and%20sand%20palette%2C%20natural%20daylight%2C%20editorial%20photography&width=600&height=340&seq=teaser-7-v2&orientation=landscape',
    imageAlt: 'Best Sugargoo Spreadsheet 2026 - Ultimate shopping guide',
    slug: '/article/best-sugargoo-spreadsheet-2026',
    internal: true,
  },
  {
    title: 'How to Use Sugargoo Spreadsheet: Step-by-Step Tutorial',
    excerpt: 'A practical step-by-step walkthrough showing exactly how to navigate categories, find products, and place orders using the Sugargoo Spreadsheet efficiently.',
    category: 'Tutorial',
    readTime: '6 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20tutorial%20concept%20with%20step%20by%20step%20instructions%20displayed%20on%20a%20clean%20screen%2C%20keyboard%20and%20mouse%20on%20a%20minimal%20desk%2C%20warm%20cream%20and%20terracotta%20palette%2C%20soft%20natural%20lighting%2C%20educational%20editorial%20style&width=600&height=340&seq=teaser-8-v2&orientation=landscape',
    imageAlt: 'How to Use Sugargoo Spreadsheet - Step by step tutorial',
    slug: 'https://kaspreadsheet.com',
    internal: false,
  },
  {
    title: 'Sugargoo Shopping Tips: 15 Expert Tricks for Smart Buyers',
    excerpt: '15 expert tips and tricks from experienced Sugargoo shoppers covering product selection, sizing, quality checking, shipping optimization, and money-saving hacks.',
    category: 'Tips & Tricks',
    readTime: '7 min read',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20clever%20shopping%20tips%20concept%20with%20fashion%20accessories%20arranged%20on%20a%20minimal%20desk%20next%20to%20a%20laptop%2C%20warm%20sand%20and%20peach%20palette%2C%20soft%20natural%20daylight%2C%20modern%20lifestyle%20editorial%20photography&width=600&height=340&seq=teaser-9-v2&orientation=landscape',
    imageAlt: 'Sugargoo Shopping Tips - 15 Expert Tricks for Smart Buyers',
    slug: 'https://kaspreadsheet.com',
    internal: false,
  },
];

export default function ArticleTeaser() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
            SEO Articles
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Complete Guides & Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Dive deeper with our comprehensive library of articles covering every aspect of Sugargoo — from beginner guides and reviews to shipping tips and money-saving strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {teaserArticles.map((article, idx) => {
            if (article.internal) {
              return (
                <article
                  key={idx}
                  className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
                >
                  <div className="w-full h-44 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.imageAlt}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                      {article.excerpt}
                    </p>
                    <a
                      href={article.slug}
                      className="inline-flex items-center gap-1.5 mt-3 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Read Full Article
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </article>
              );
            }
            return (
              <article
                key={idx}
                className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                    {article.excerpt}
                  </p>
                  <a
                    href={article.slug}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-1.5 mt-3 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Read on Main Site
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}